//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      icon: require("@/assets/image/icon/icon_pay_fail.png"),
      objType:"",
      id:"",
      columnCode:"",
      payType:'',
      orderId:'',
      action:'fail',
      reUrl:null,
    };
  },
  methods: {
    backHome(){
        this.$routerHelper.goPageByThird('home',{
            columnCode: this.columnCode,
            id: this.id,
            objType:this.objType,
          })
    },
    buyResetOrder(){
        this.$routerHelper.goPageByThird('buy',{
            columnCode: this.columnCode,
            id: this.id,
            objType:this.objType,
            retry:1,
          })
    },
    pay(){
      let postD = {
        data: JSON.stringify({
            rawData: '',
            statusCode:0,//异常状态码
            client:'h5',
            type:this.payType,
            result:this.action == 'cancel'?'-2':'-1',//0成功，-1失败 -2取消 -3状态异常
            orderId:this.orderId,
            msg:this.action == 'cancel'?'第三方支付取消':'第三方支付失败'
          }),
      };
      this.GLOBAL_.ccRequest
        .doSessionAxios(this.CONFIG.H5BUY.PAY, postD, "POST")
        .then((res) => {
          // console.log("this.reUrl",this.reUrl);
          this.UTILS.hideLoading()
          if(this.reUrl && this.reUrl!='null'){
            setTimeout(() => {
                window.location.href = this.reUrl;
              }, 2000); // 2秒延时
          }
        })
        .catch((err) => {
          let errD = err.response.data;
          console.log("提交支付結果異常",errD.code,errD.message);
          this.UTILS.showToast(errD.message);
          this.UTILS.hideLoading();
        });
    },
  },
  mounted() {
      history.replaceState({}, '', '/');
      console.log(this.$route.query)
      this.objType = this.$route.query.objType || null;
      this.id = this.$route.query.id || null;
      this.columnCode = this.$route.query.columnCode || null;
      this.payType = this.$route.query.payType || null;
      this.orderId = this.$route.query.orderId || null;
      this.action = this.$route.query.action || null;
      this.reUrl = this.$route.query.reUrl || null;
      console.log("mounted.reUrl",this.reUrl);
      if(this.orderId){
        this.pay()
      }
  },
};



// WEBPACK FOOTER //
// ./src/pages/buy/buyFail.vue